import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Alert, AlertTitle } from '@/molecules/Alert';
import { TablePageLayout } from '@/templates/TablePageLayout';

/**
 * AlertsExample
 * Example alerts feed page using the Alert molecule for inline notifications.
 */
export function AlertsExample() {
  return (
    <Box sx={{ p: 3 }}>
      <TablePageLayout title="Alerts" description="Recent system and security alerts.">
        <Stack spacing={2} sx={{ maxWidth: 720 }}>
          <Alert severity="error">
            <AlertTitle>Critical attack path detected</AlertTitle>
            Internet-facing ALB has a direct path to prod-db-01.
          </Alert>
          <Alert severity="warning">3 assets are missing the AiStrike agent.</Alert>
          <Alert severity="info">Weekly posture report is ready.</Alert>
          <Alert severity="success">12 findings were auto-remediated overnight.</Alert>
        </Stack>
      </TablePageLayout>
    </Box>
  );
}
